"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _Radio = require("../Radio");
var _Fieldset = require("../Fieldset");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
## Usage

```js
import { RadioGroup } from '@farewill/ui'
```

## Notes

`<RadioGroup>` creates a set of `<Radio>` buttons and handles their internal checked state. It extends from `<Fieldset>` for its layout functionality.
 */
const RadioGroup = _ref => {
  let {
    value,
    name,
    onChange,
    options,
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Fieldset.Fieldset, props, options.map(_ref2 => {
    let {
      value: radioValue,
      ...optionProps
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Radio.Radio, _extends({
      key: JSON.stringify(radioValue)
    }, optionProps, {
      checked: value === undefined ? undefined : value === radioValue,
      name: name,
      value: radioValue,
      size: size,
      onChange: onChange
    }));
  }));
};
exports.RadioGroup = RadioGroup;
RadioGroup.defaultProps = {
  size: 'M'
};